import type { DataRoomFile } from "@vega-api/generated/types/dataRoomFile";
import {
  DocumentExtentions,
  PDF_MIME_TYPES,
} from "@vega-core/constants/documents";

const PDF_EXTENSION = `.${DocumentExtentions.PDF}`;

type FileNode = {
  children?: unknown[];
  createdAt?: string | null;
  depth?: number;
  file?: Partial<DataRoomFile> & Pick<DataRoomFile, "contentType" | "fileName">;
  id?: string;
  isDownloadable?: boolean;
  isFolder?: boolean;
  isNew?: boolean;
  name?: string;
  parentId?: string | null;
  path?: string;
  type?: string;
};

export function isViewableInApp(node: FileNode): boolean {
  const contentType = node.file?.contentType.trim().toLowerCase();

  if (contentType && contentType in PDF_MIME_TYPES) return true;

  const fileName = node.file?.fileName ?? node.name;

  return fileName?.toLowerCase().endsWith(PDF_EXTENSION) ?? false;
}
